<template>
  <div>
    <div
      class="event-detail forsiga"
      v-if="EventDetail && Object.keys(EventDetail).length"
    >
      <div class="content">
        <div class="first-banner">
          <div class="first-banner__text">
            <div class="first-banner__title">
              Всем сердцем: открываем новые горизонты в терапии ХСН
            </div>
            <div
              class="button first-banner__button button_blue"
              @click="toRegister(true)"
              v-if="!!!Object.keys(user).length && !!$route.query.access"
            >
              Зарегистрироваться
            </div>
          </div>
          <picture>
            <source
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/forsiga/banner_mob.jpg`"
              media="(max-width: 767px)"
            />
            <source
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/forsiga/banner_tab.jpg`"
              media="(max-width: 1219px)"
            />
            <source
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/forsiga/banner.jpg`"
              media="(min-width: 1220px)"
            />
            <img
              class="first-banner__image"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/forsiga/banner.jpg`"
            />
          </picture>
        </div>
        <div class="event-detail__about-description mt-12">
          Рады сообщить, что скоро Вас ожидает важная и теплая встреча
          экспертов! Девиз встречи — «Всем Сердцем», и он выбран не случайно.
          Выбирая жизнь всем сердцем, мы получаем удивительную возможность
          любить, творить, познавать и делиться самым важным. Приглашаем Вас
          вместе с ведущими экспертами открыть новую страницу в кардиологии!
        </div>

        <div class="event-detail__timer mb-0">
          <div class="event-detail__timer-title">
            {{
              !Object.keys(timerResult).length
                ? "Смотреть запись вебинара"
                : timerResult.months
                ? "Подключение к трансляции:"
                : "Трансляция начнется через:"
            }}
          </div>
          <div
            class="event-detail__timer-date mt-sm-4"
            v-if="timerResult.months"
          >
            {{ $m(EventDetail.date).format("DD MMMM") }}
            в
            {{
              $m
                .utc(EventDetail.date)
                .utcOffset(+3)
                .subtract(10, "minutes")
                .format("HH:mm")
            }}
            (МСК)
          </div>
          <div
            v-else-if="Object.keys(timerResult).length"
            class="event-detail__timer-row"
          >
            <div class="event-detail__timer-item" v-if="timerResult.months">
              <div class="timer__value">{{ timerResult.months }}</div>
              <div class="timer__text">Месяцев</div>
            </div>
            <div class="event-detail__timer-item" v-if="timerResult.days > 0">
              <div class="timer__value">{{ timerResult.days }}</div>
              <div class="timer__text">
                {{  helpers.getNoun(timerResult.days, "день", "дня", "дней") }}
              </div>
            </div>
            <div class="event-detail__timer-item" v-if="timerResult.hours > 0">
              <div class="timer__value">{{ timerResult.hours }}</div>
              <div class="timer__text">
                {{  helpers.getNoun(timerResult.hours, "час", "часа", "часов") }}
              </div>
            </div>
            <div
              class="event-detail__timer-item"
              v-if="timerResult.minutes > 0"
            >
              <div class="timer__value">{{ timerResult.minutes }}</div>
              <div class="timer__text">
                {{  helpers.getNoun(timerResult.minutes, "минуту", "минуты", "минут") }}
              </div>
            </div>
            <div
              class="event-detail__timer-item"
              v-if="timerResult.seconds > 0"
            >
              <div class="timer__value">{{ timerResult.seconds }}</div>
              <div class="timer__text">
                {{
                   helpers.getNoun(timerResult.seconds, "секунду", "секунды", "секунд")
                }}
              </div>
            </div>
          </div>
          <div
            v-if="!Object.keys(timerResult).length"
            @click="openIframe()"
            class="event-detail__translation button button_white-blue px-6"
          >
            Смотреть
          </div>
        </div>

        <div class="event-detail__warning d-flex mt-6" v-if="false">
          <svg
            class="mr-2"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16ZM30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16ZM15.3595 23.5C14.8366 23.5 14.5 23.066 14.5 22.5553V14.7511C14.5 14.2404 14.8366 13.8064 15.3595 13.8064H16.6144C17.1373 13.8064 17.5 14.2404 17.5 14.7511V22.5553C17.5 23.066 17.1373 23.5 16.6144 23.5H15.3595ZM16 8C16.8284 8 17.5 8.67157 17.5 9.5C17.5 10.3284 16.8284 11 16 11C15.1716 11 14.5 10.3284 14.5 9.5C14.5 8.67157 15.1716 8 16 8Z"
              fill="#2186AF"
            />
          </svg>
          <span>
            Коллеги, если у вас возникают проблемы с регистрацией, авторизацией,
            а также проблемы с подключением к трансляции, просим вас обращаться
            в тех поддержку по номеру телефона:
            <a href="tel:89126139852">8-912-613-98-52</a>.<br />
            Обращаем внимание, что техническая поддержка доступна только
            2&nbsp;сентября&nbsp;с&nbsp;9:30&nbsp;до&nbsp;10:30&nbsp;по&nbsp;МСК
          </span>
        </div>

        <div class="event-detail__date-info" v-if="false">
          <div class="event-detail__date-text">
            <div class="event-detail__date-item" v-if="EventDetail.date && false">
              <div class="event-detail__date-item-title">Дата и время</div>
              <div class="event-detail__date-item-value">
                {{ $m(EventDetail.date).format("DD MMMM") }},
                {{
                  $m
                    .utc(EventDetail.date)
                    .utcOffset(+3)
                    .format("HH:mm")
                }}
                (мск)
              </div>
            </div>
            <div class="event-detail__date-item" v-if="EventDetail.place">
              <div class="event-detail__date-item-title">Место</div>
              <div class="event-detail__date-item-value">
                {{ EventDetail.place }}
              </div>
            </div>
            <div class="event-detail__date-item">
              <div class="event-detail__date-item-title">Формат</div>
              <div class="event-detail__date-item-value">
                Очно + онлайн трансляция
              </div>
            </div>
          </div>
          <div
            class="event-detail__add-calendar button button_blue"
            @click="getCalendar(EventDetail.id)"
          >
            Добавить в календарь
          </div>
        </div>
        <DefaultSlider :color="'#2186AF'" :title="'Наши эксперты'">
          <template #items>
            <div
              class="slide-lector"
              v-for="(lector, ind) in lectors"
              :key="ind"
            >
              <div class="slide-lector__image-container">
                <img class="slide-lector__image" :src="lector.image" />
              </div>
              <div class="slide-lector__tag" v-html="lector.tag"></div>
              <div class="slide-lector__name" v-html="lector.name"></div>
              <div
                class="slide-lector__description"
                v-html="lector.description"
              ></div>
            </div>
          </template>
        </DefaultSlider>
        <InfoDrop
          @openInner="openInner(true)"
          :item="{
            title: 'Программа на 2 сентября',
            content: galaxyProgramm,
          }"
        />
        <div class="hobl-activities mt-16">
          <div class="hobl-activities__title">
            В период ожидания эфира, мы предлагаем вам пройти несколько полезных
            активностей
          </div>

          <div class="hobl-activities__list">
            <div class="hobl-activities__item">
              <div class="hobl-activity__icon">
                <img :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/forsiga/icon1.svg`" />
              </div>
              <div
                class="hobl-activity__button button"
                @click="toWidget('find_word', 'Филворд')"
              >
                Филворд
              </div>
            </div>
            <div class="hobl-activities__item">
              <div class="hobl-activity__icon">
                <img :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/forsiga/icon2.svg`" />
              </div>
              <div
                class="hobl-activity__button button"
                @click="toWidget('digital_quiz', 'Квиз')"
              >
                Квиз
              </div>
            </div>
            <div class="hobl-activities__item">
              <div class="hobl-activity__icon">
                <img :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/forsiga/icon3.svg`" />
              </div>
              <div
                class="hobl-activity__button button"
                @click="toWidget('true_false', 'Викторина')"
              >
                Викторина
              </div>
            </div>
            <!-- <div class="hobl-activities__item">
              <div class="hobl-activity__icon">
                <img :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/forsiga/icon4.svg`" />
              </div>
              <div
                class="hobl-activity__button button"
                @click="toWidget('feedback', 'Обратная связь')"
              >
                Обратная связь
              </div>
            </div> -->
          </div>
        </div>
        <div
          class="bottom-banner"
          v-if="!!!Object.keys(user).length && !!$route.query.access"
        >
          <picture>
            <source
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/forsiga/bottom-banner_mob.jpg`"
              media="(max-width: 767px)"
            />
            <source
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/forsiga/bottom-banner_tab.jpg`"
              media="(max-width: 1219px)"
            />
            <source
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/forsiga/bottom-banner.jpg`"
              media="(min-width: 1220px)"
            />
            <img
              class="bottom-banner__image"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/forsiga/bottom-banner.jpg`"
            />
          </picture>
          <div class="bottom-banner__text">
            <div class="bottom-banner__logo">
              <svg
                width="167"
                height="52"
                viewBox="0 0 167 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_10037_28230)">
                  <path
                    d="M83.7578 33.7077V31.5825L85.9381 31.1685V16.1684L83.7578 15.7544V13.6155H85.9381H90.9198L96.8122 28.1464H96.895L102.608 13.6155H109.853V15.7544L107.659 16.1684V31.1685L109.853 31.5825V33.7077H102.001V31.5825L104.305 31.1685V26.4905L104.333 17.7002L104.264 17.6864L98.0404 33.2523H95.5151L89.112 17.7691L89.0431 17.7829L89.2224 26.2559V31.1685L91.6098 31.5825V33.7077H83.7578Z"
                    fill="#830051"
                  />
                  <path
                    d="M120.506 33.9975C119.172 33.9975 117.967 33.7491 116.891 33.2523C115.814 32.7463 114.89 32.0379 114.117 31.1271C113.353 30.2164 112.765 29.14 112.351 27.898C111.937 26.6561 111.73 25.2945 111.73 23.8134V23.5098C111.73 22.0378 111.937 20.6809 112.351 19.4389C112.765 18.1969 113.353 17.1206 114.117 16.2098C114.89 15.2898 115.814 14.5814 116.891 14.0847C117.967 13.5787 119.168 13.3257 120.492 13.3257C121.863 13.3257 123.091 13.5787 124.177 14.0847C125.262 14.5814 126.187 15.2898 126.95 16.2098C127.714 17.1206 128.298 18.1969 128.703 19.4389C129.108 20.6809 129.31 22.0378 129.31 23.5098V23.8134C129.31 25.2945 129.108 26.6561 128.703 27.898C128.298 29.14 127.714 30.2164 126.95 31.1271C126.187 32.0379 125.262 32.7463 124.177 33.2523C123.091 33.7491 121.868 33.9975 120.506 33.9975ZM120.506 31.2375C121.72 31.2375 122.719 30.9293 123.501 30.313C124.292 29.6874 124.876 28.818 125.253 27.7048C125.64 26.5917 125.833 25.2945 125.833 23.8134V23.4822C125.833 22.0194 125.64 20.7361 125.253 19.6321C124.867 18.5281 124.278 17.6634 123.487 17.0378C122.705 16.4122 121.707 16.0994 120.492 16.0994C119.333 16.0994 118.363 16.4122 117.581 17.0378C116.799 17.6634 116.21 18.5281 115.814 19.6321C115.419 20.7361 115.221 22.0194 115.221 23.4822V23.8134C115.221 25.2853 115.419 26.5825 115.814 27.7048C116.21 28.818 116.799 29.6874 117.581 30.313C118.372 30.9293 119.347 31.2375 120.506 31.2375Z"
                    fill="#830051"
                  />
                  <path
                    d="M138.915 33.9975C137.544 33.9975 136.27 33.8273 135.092 33.4869C133.915 33.1465 132.769 32.5807 131.656 31.7895V27.1667H134.347L134.789 30.1612C135.276 30.5108 135.874 30.7913 136.583 31.0029C137.3 31.2145 138.078 31.3203 138.915 31.3203C139.734 31.3203 140.419 31.2053 140.971 30.9753C141.532 30.7362 141.96 30.405 142.254 29.9818C142.549 29.5586 142.696 29.0572 142.696 28.4776C142.696 27.944 142.567 27.4703 142.309 27.0563C142.052 26.6423 141.624 26.2743 141.026 25.9523C140.428 25.6211 139.619 25.3175 138.597 25.0415C137.098 24.6367 135.842 24.1584 134.83 23.6064C133.827 23.0544 133.068 22.392 132.553 21.6192C132.047 20.8465 131.794 19.9357 131.794 18.8869C131.794 17.8105 132.084 16.8584 132.664 16.0304C133.252 15.2024 134.066 14.5492 135.106 14.0709C136.146 13.5925 137.346 13.3487 138.708 13.3395C140.198 13.3211 141.514 13.5143 142.654 13.9191C143.804 14.3239 144.775 14.8528 145.566 15.506V19.8253H142.93L142.434 17.0102C142.056 16.7434 141.564 16.518 140.957 16.334C140.359 16.1408 139.651 16.0442 138.832 16.0442C138.133 16.0442 137.516 16.1592 136.983 16.3892C136.449 16.6192 136.031 16.9458 135.727 17.369C135.423 17.7829 135.272 18.2797 135.272 18.8593C135.272 19.3653 135.405 19.8069 135.672 20.1841C135.939 20.5613 136.385 20.9063 137.01 21.219C137.636 21.5226 138.482 21.8308 139.55 22.1436C141.73 22.7232 143.381 23.5236 144.504 24.5447C145.626 25.5659 146.187 26.8677 146.187 28.45C146.187 29.5632 145.884 30.5384 145.276 31.3755C144.678 32.2035 143.832 32.8475 142.737 33.3075C141.652 33.7675 140.377 33.9975 138.915 33.9975Z"
                    fill="#830051"
                  />
                  <path
                    d="M152.866 33.7077V31.5825L155.06 31.1685V16.2788H151.017L150.713 18.8455H148.105V13.6155H165.507V18.8455H162.885L162.581 16.2788H158.538V31.1685L160.732 31.5825V33.7077H152.866Z"
                    fill="#830051"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M66.9465 18.7551C66.9465 20.2106 65.7666 21.3905 64.3111 21.3905C62.8557 21.3905 61.6758 20.2106 61.6758 18.7551C61.6758 17.2997 62.8557 16.1198 64.3111 16.1198C65.7666 16.1198 66.9465 17.2997 66.9465 18.7551ZM72.9782 23.2731C72.9782 24.7285 71.7983 25.9084 70.3428 25.9084C68.8873 25.9084 67.7075 24.7285 67.7075 23.2731C67.7075 21.8176 68.8873 20.6377 70.3428 20.6377C71.7983 20.6377 72.9782 21.8176 72.9782 23.2731ZM74.1063 31.9319C75.5618 31.9319 76.7417 30.7521 76.7417 29.2966C76.7417 27.8411 75.5618 26.6612 74.1063 26.6612C72.6509 26.6612 71.471 27.8411 71.471 29.2966C71.471 30.7521 72.6509 31.9319 74.1063 31.9319ZM75.989 37.579C75.989 39.0345 74.8091 40.2144 73.3536 40.2144C71.8982 40.2144 70.7183 39.0345 70.7183 37.579C70.7183 36.1235 71.8982 34.9437 73.3536 34.9437C74.8091 34.9437 75.989 36.1235 75.989 37.579ZM70.3428 46.2379C71.7983 46.2379 72.9782 45.058 72.9782 43.6025C72.9782 42.1471 71.7983 40.9672 70.3428 40.9672C68.8873 40.9672 67.7075 42.1471 67.7075 43.6025C67.7075 45.058 68.8873 46.2379 70.3428 46.2379ZM66.1938 48.1205C66.1938 49.5759 65.0139 50.7558 63.5584 50.7558C62.103 50.7558 60.9231 49.5759 60.9231 48.1205C60.9231 46.665 62.103 45.4851 63.5584 45.4851C65.0139 45.4851 66.1938 46.665 66.1938 48.1205ZM54.526 51.5085C55.9814 51.5085 57.1613 50.3286 57.1613 48.8732C57.1613 47.4177 55.9814 46.2378 54.526 46.2378C53.0705 46.2378 51.8906 47.4177 51.8906 48.8732C51.8906 50.3286 53.0705 51.5085 54.526 51.5085Z"
                    fill="#830051"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M67.7086 10.0959C67.7086 10.9276 67.0344 11.6019 66.2027 11.6019C65.371 11.6019 64.6968 10.9276 64.6968 10.0959C64.6968 9.26425 65.371 8.59003 66.2027 8.59003C67.0344 8.59003 67.7086 9.26425 67.7086 10.0959ZM63.1924 10.0961C63.1924 10.9278 62.5182 11.602 61.6865 11.602C60.8548 11.602 60.1806 10.9278 60.1806 10.0961C60.1806 9.2644 60.8548 8.59018 61.6865 8.59018C62.5182 8.59018 63.1924 9.2644 63.1924 10.0961ZM57.1703 13.8608C58.002 13.8608 58.6762 13.1865 58.6762 12.3548C58.6762 11.5231 58.002 10.8489 57.1703 10.8489C56.3386 10.8489 55.6644 11.5231 55.6644 12.3548C55.6644 13.1865 56.3386 13.8608 57.1703 13.8608ZM56.4181 16.1195C56.4181 16.9512 55.7439 17.6254 54.9122 17.6254C54.0805 17.6254 53.4062 16.9512 53.4062 16.1195C53.4062 15.2878 54.0805 14.6135 54.9122 14.6135C55.7439 14.6135 56.4181 15.2878 56.4181 16.1195ZM54.9122 22.1433C55.7439 22.1433 56.4181 21.4691 56.4181 20.6374C56.4181 19.8057 55.7439 19.1315 54.9122 19.1315C54.0805 19.1315 53.4062 19.8057 53.4062 20.6374C53.4062 21.4691 54.0805 22.1433 54.9122 22.1433ZM58.6762 24.4022C58.6762 25.2339 58.002 25.9081 57.1703 25.9081C56.3386 25.9081 55.6644 25.2339 55.6644 24.4022C55.6644 23.5705 56.3386 22.8963 57.1703 22.8963C58.002 22.8963 58.6762 23.5705 58.6762 24.4022ZM60.9338 27.414C61.7655 27.414 62.4397 26.7398 62.4397 25.9081C62.4397 25.0764 61.7655 24.4021 60.9338 24.4021C60.1021 24.4021 59.4279 25.0764 59.4279 25.9081C59.4279 26.7398 60.1021 27.414 60.9338 27.414ZM66.2032 28.167C66.2032 28.9987 65.529 29.6729 64.6973 29.6729C63.8656 29.6729 63.1914 28.9987 63.1914 28.167C63.1914 27.3353 63.8656 26.661 64.6973 26.661C65.529 26.661 66.2032 27.3353 66.2032 28.167ZM66.9554 33.4376C67.7871 33.4376 68.4613 32.7634 68.4613 31.9317C68.4613 31.1 67.7871 30.4258 66.9554 30.4258C66.1237 30.4258 65.4495 31.1 65.4495 31.9317C65.4495 32.7634 66.1237 33.4376 66.9554 33.4376ZM68.4613 35.6965C68.4613 36.5282 67.7871 37.2024 66.9554 37.2024C66.1237 37.2024 65.4495 36.5282 65.4495 35.6965C65.4495 34.8648 66.1237 34.1906 66.9554 34.1906C67.7871 34.1906 68.4613 34.8648 68.4613 35.6965ZM64.6973 40.967C65.529 40.967 66.2032 40.2928 66.2032 39.4611C66.2032 38.6294 65.529 37.9552 64.6973 37.9552C63.8656 37.9552 63.1914 38.6294 63.1914 39.4611C63.1914 40.2928 63.8656 40.967 64.6973 40.967ZM62.4397 41.7202C62.4397 42.5519 61.7655 43.2261 60.9338 43.2261C60.1021 43.2261 59.4279 42.5519 59.4279 41.7202C59.4279 40.8885 60.1021 40.2143 60.9338 40.2143C61.7655 40.2143 62.4397 40.8885 62.4397 41.7202ZM55.6649 43.9788C56.4966 43.9788 57.1708 43.3046 57.1708 42.4729C57.1708 41.6412 56.4966 40.967 55.6649 40.967C54.8332 40.967 54.159 41.6412 54.159 42.4729C54.159 43.3046 54.8332 43.9788 55.6649 43.9788Z"
                    fill="#9DB0AC"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M69.9682 2.94303C69.9682 4.39849 68.7883 5.57838 67.3329 5.57838C65.8774 5.57838 64.6975 4.39849 64.6975 2.94303C64.6975 1.48756 65.8774 0.307678 67.3329 0.307678C68.7883 0.307678 69.9682 1.48756 69.9682 2.94303ZM60.9257 3.69605C60.9257 5.15151 59.7459 6.3314 58.2904 6.3314C56.8349 6.3314 55.655 5.15151 55.655 3.69605C55.655 2.24058 56.8349 1.0607 58.2904 1.0607C59.7459 1.0607 60.9257 2.24058 60.9257 3.69605ZM51.5161 10.849C52.9715 10.849 54.1514 9.66915 54.1514 8.21368C54.1514 6.75822 52.9715 5.57833 51.5161 5.57833C50.0606 5.57833 48.8807 6.75822 48.8807 8.21368C48.8807 9.66915 50.0606 10.849 51.5161 10.849ZM51.1406 14.2374C51.1406 15.6928 49.9607 16.8727 48.5052 16.8727C47.0498 16.8727 45.8699 15.6928 45.8699 14.2374C45.8699 12.7819 47.0498 11.602 48.5052 11.602C49.9607 11.602 51.1406 12.7819 51.1406 14.2374ZM47.7525 24.4023C49.208 24.4023 50.3879 23.2224 50.3879 21.7669C50.3879 20.3114 49.208 19.1316 47.7525 19.1316C46.2971 19.1316 45.1172 20.3114 45.1172 21.7669C45.1172 23.2224 46.2971 24.4023 47.7525 24.4023ZM54.1514 28.5438C54.1514 29.9992 52.9715 31.1791 51.5161 31.1791C50.0606 31.1791 48.8807 29.9992 48.8807 28.5438C48.8807 27.0883 50.0606 25.9084 51.5161 25.9084C52.9715 25.9084 54.1514 27.0883 54.1514 28.5438ZM57.5377 35.6967C58.9932 35.6967 60.173 34.5169 60.173 33.0614C60.173 31.6059 58.9932 30.426 57.5377 30.426C56.0822 30.426 54.9023 31.6059 54.9023 33.0614C54.9023 34.5169 56.0822 35.6967 57.5377 35.6967Z"
                    fill="#F0AB00"
                  />
                  <path
                    d="M1.28125 33.7077V31.5825L2.74401 31.3755L9.3954 13.6155H12.7763L19.3449 31.3755L20.8077 31.5825V33.7077H14.4184V31.5825L15.8536 31.3203L14.791 28.1602H7.31167L6.2215 31.3203L7.67045 31.5825V33.7077H1.28125ZM8.22244 25.4969H13.8941L11.2859 18.0589L11.1065 17.5208H11.0238L10.8306 18.0865L8.22244 25.4969Z"
                    fill="#F0AB00"
                  />
                  <path
                    d="M22.6706 33.7077V31.3065L32.7443 16.3064H25.9135L25.6237 18.8869H22.919L23.0156 13.6155H36.9256V15.9476L26.8105 31.0305H34.4554L34.7452 28.3396H37.4361L37.2981 33.7077H22.6706Z"
                    fill="#F0AB00"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_10037_28230">
                    <rect
                      width="167"
                      height="51.3846"
                      fill="white"
                      transform="translate(0 0.307678)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div class="bottom-banner__description">
              Коллекция статей, клинических случаев, вебинаров и конференций от
              лучших специалистов со всего мира.
            </div>
            <div
              class="bottom-banner__button button button_blue"
              @click="toRegister"
            >
              Присоединиться
            </div>
          </div>
        </div>
        <InfoDrop
          @openInner="openInner"
          :item="{
            title: 'Список сокращений',
            content: shortsList,
          }"
        />
      </div>
      <LibrarySlider
        v-if="sliderItems && sliderItems.length && !sliderItems.includes(null)"
        :items="sliderItems"
        :color="'#2186AF'"
        :title="'Это может быть полезным'"
        @clickMaterials="clickMaterials"
      />
    </div>
    <div v-else-if="EventDetail === 404"><Choch class="inPage" /></div>
    <div v-else-if="EventDetail === false"><Error class="inPage" /></div>
    <PopUpDefault @close="popupActivity = false" v-if="popupActivity">
      <div
        class="find_word"
        v-if="popupType === 'find_word'"
        id="otp_wgt_xcxkw37edfwka"
      ></div>
      <div class="digital_quiz" v-if="popupType === 'digital_quiz'">
        <div
          data-tf-widget="nCcEzbDC"
          data-tf-opacity="100"
          data-tf-hide-headers=""
          data-tf-inline-on-mobile=""
          data-tf-iframe-props="title=Квиз"
          data-tf-medium="snippet"
          style="width: 100%; height: 100%"
        ></div>
      </div>
      <div class="true_false" v-if="popupType === 'true_false'">
        <iframe
          style="max-width: 100%"
          src="https://wordwall.net/ru/embed/572df6ccb54849058d279400f9d9ab3c?themeId=4&templateId=5&fontStackId=0"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
      <div class="feedback" v-if="popupType === 'feedback'">
        <iframe
          src="https://forms.yandex.ru/u/64f1fa2e6938726fbc8aa0bd/?iframe=1"
          frameborder="0"
          name="ya-form-64f1fa2e6938726fbc8aa0bd"
          width="650"
        ></iframe>
      </div>
    </PopUpDefault>
    <Facecast
      :slug="'forsiga'"
      :record="`https://storage.yandexcloud.net/${$root.backetName}/media/content/forsiga/05_09_AZ_forsiga.mp4`"
      @closeFrame="openFrame = false"
      :open="openFrame"
    />
    <PopupEnd
      :eventName="'forsiga0209'"
      :backUrl="{ name: 'Forsiga' }"
      @close="closePopup"
      v-if="popup && $route.query.access"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Breadcrumbs from "../../components/pageComponents/Breadcrumbs.vue";
import InfoDrop from "../../components/pageComponents/InfoDrop.vue";
import PopupEnd from "@/components/pageComponents/PopUpEventEnd.vue";
import LibrarySlider from "@/components/pageComponents/LibrarySlider.vue";
import DefaultSlider from "@/components/pageComponents/DefaultSlider.vue";
import Facecast from "@/components/main/events/Facecast.vue";
import Choch from "@/views/404.vue";
import Error from "@/views/Error.vue";
import PopUpDefault from "@/components/pageComponents/PopUpDefault.vue";
export default {
  metaInfo() {
    if (this.EventDetail.name) {
      return {
        title: "Az-most - " + this.EventDetail.name.replace(/<[^>]*>?/gm, ""),
      };
    } else {
      return { title: "Az-most - " + this.EventDetail.name };
    }
  },
  name: "EventDetail",
  components: {
    Breadcrumbs,
    InfoDrop,
    Choch,
    Error,
    PopupEnd,
    PopUpDefault,
    LibrarySlider,
    DefaultSlider,
    PopUpDefault,
    Facecast,
  },
  data: () => ({
    popup: false,
    popupActivity: false,
    popupType: "",
    openFrame: false,
    timerResult: { id: 0 },
    timerResultEnd: {},
    interval: null,
    percent: null,
  }),
  computed: {
    ...mapGetters(["user", "TextList", "VideoList", "PodcastsList"]),
    sliderItems() {
      let arr = [];
      if (this.PodcastsList && this.PodcastsList.length) {
        arr = arr.concat(
          this.PodcastsList.map((el) => ({ ...el, page: "PodcastDetail" }))
        );
      }
      if (this.TextList && this.TextList.length) {
        arr = arr.concat(
          this.TextList.map((el) => ({ ...el, page: "TextDetail" }))
        );
      }
      if (this.VideoList && this.VideoList.length) {
        arr = arr.concat(
          this.VideoList.map((el) => ({ ...el, page: "VideoDetail" }))
        );
      }
      return arr;
    },
    shortsList() {
      return `<div class="short-list">ХСН — Хроническая сердечная недостаточность; <br><br>
ФВ ЛЖ — Фракция выброса левого желудочка; <br><br>
СД2 — Сахарный диабет 2 типа; <br><br>
ХБП — Хроническая болезнь почек; <br><br>
СНсФВ — Сердечная недостаточность с сохранной фракцией выброса;<br><br>
РАН — Российская академия наук; <br><br>
Д.м.н. — Доктор медицинский наук;<br><br>
ФУВ Волгоградского государственного медицинского университета — Факультет усовершенствования врачей Волгоградского государственного медицинского университета; <br><br>
РФ — Российская Федерация;<br><br>
РУДН — Российский университет дружбы народов;<br><br>
ФГБУ ВО «Московский государственный медико-стоматологический университет имени А.И. Евдокимова» — Федеральное государственное бюджетное образовательное учреждение высшего образования «Московский государственный медико-стоматологический университетимени А. И. Евдокимова»;<br><br>
МКНЦ имени А.С. Логинова — Московский клинический научный центр имени А. С. Логинова;<br><br>
ФГБУ «НМИЦ им. В. А. Алмазова» Минздрава России — Федеральное государственное бюджетное учреждение «Национальный медицинский исследовательский центр имени В. А. Алмазова»; <br><br>
ФГБУ «НМИЦК им. ак. Е.И. Чазова» Минздрава России — Федеральное государственное бюджетное учреждение «Национальный медицинский исследовательский центр имени академика Е.И. Чазова».</div>`;
    },
    lectors() {
      return [
        {
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/forsiga/lopatin.png`,
          tag: "Спикер",
          name: "Лопатин Юрий Михайлович",
          description:
            "Член-корр РАН., профессор, д.м.н. заведующий кафедрой кардиологии и функциональной диагностики ФУВ Волгоградского государственного медицинского университета, заведующий кардиологическим отделением №1 Волгоградского областного клинического кардиологического центра, Заслуженный врач Российской Федерации, член правления Общества специалистов по сердечной недостаточности РФ, Член президиума правления Российского кардиологического общества",
        },
        {
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/forsiga/kobalava.png`,
          tag: "Спикер",
          name: "Калашников Виктор Юрьевич",
          description:
            "Член-корреспондент РАН, профессор, д.м.н., анестезиолог-реаниматолог,кардиолог. Заместитель директора Центра по координации эндокринологической службы. Заведующий отделом кардиологии",
        },
        {
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/forsiga/mkrtumyan.png`,
          tag: "Спикер",
          name: "Мкртумян Ашот Мусаелович",
          description:
            "Заслуженный врач РФ, доктор медицинских наук, профессор. Заведующий кафедрой эндокринологии и диабетологии лечебного факультета МГМСУ им. А.И. Евдокимова. Руководитель научного отдела эндокринных и метаболических нарушений МКНЦ имени А.С. Логинова",
        },
        {
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/forsiga/villevalde.png`,
          tag: "Спикер",
          name: "Виллевальде Светлана Вадимовна",
          description:
            "Д.м.н., профессор, начальник службы анализа и перспективного планирования, заведующая кафедрой кардиологии ФГБУ «НМИЦ им. В. А. Алмазова» Минздрава России (г. Санкт-Петербург)",
        },
        {
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/forsiga/ageev.png`,
          tag: "Спикер",
          name: "Агеев Фаиль Таипович",
          description:
            "Д.м.н., профессор, руководитель научно-диспансерного отдела ФГБУ «НМИЦК им. ак. Е.И. Чазова» Минздрава России",
        },
        {
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/forsiga/ovchinnikov.png`,
          tag: "Спикер",
          name: "Овчинников Артем Германович",
          description:
            "Д.м.н., ведущий научный сотрудник ФГБУ «НМИЦК им. ак. Е.И. Чазова» Минздрава России",
        },
        {
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/forsiga/tereshenko.png`,
          tag: "Спикер",
          name: "Терещенко Сергей Николаевич",
          description:
            "Д. м. н., профессор, руководитель отдела заболеваний миокарда и сердечной недостаточности ФГБУ «НМИЦК им. ак. Е.И. Чазова» Минздрава России, Заслуженный деятель науки РФ.",
        },
        {
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/forsiga/jirov.png`,
          tag: "Спикер",
          name: "Жиров Игорь Витальевич",
          description:
            "Д. м. н., профессор, ведущий научный сотрудник ФГБУ «НМИЦК им. ак. Е.И. Чазова» Минздрава России",
        },
      ];
    },
    EventDetail() {
      return {
        id: 259, // 66 - dev 222 -prod
        types: [
          {
            id: 1,
            name: "Онлайн",
            code: "online",
          },
          {
            id: 2,
            name: "Оффлайн",
            code: "offline",
          },
        ],
        name: "Всем сердцем: открываем новые горизонты в терапии ХСН",
        description: "",
        banner_description:
          "10:00 – 10:10 – «Липидная теория атеросклероза» 110 лет за 10 минут – Сусеков А.В.<br><br>10:10 – 10:30 - Программа «Галактика» в 2023 г: результаты тысяч пациентов и для уверенного решения Обрезан А.Г. (Санкт-Петербург)<br><br>10:30 – 10:50 - Безопасность терапии статинами - сквозь туманность сомнений и противоречий. Бубнова М.Г.<br><br>10:50 – 11:10 - Рекомендации 2023 по липидам: большой взрыв или вспышки на солнце? – Кобалава Ж.Д.<br><br>11:10 – 11:30 - Созвездие нестатиновой терапии: белые карлики, погасшие звезды и сверхновые. Навигация для врачей. Каштолап В.В. (Кемерово)<br><br>11:30 – 11:50 - Отклонение от статиновой орбиты и как вернуться на верный курс? – Скибицкий В.В. (Краснодар)<br><br>11:50 – 12:10 - Космический шум и информационное поле – почему важен диалог с пациентом? Воробьёв А.С. (Сургут)<br><br>12:10 – 12:30 - Дискуссия экспертов",
        date: "2023-09-01T10:00:30+03:00", 
        date_end: "2023-09-02T14:30:30+03:00",
        place:
          "г. Москва, конгресс-центр GRAND BALLROOM, Шлюзовая набережная, дом 2/1, строение 1",
      };
    },
    program() {
      return [
        {
          time: "10:00-10:05",
          title: "Приветственное слово",
          description: "Лопатин Ю.М. Член-корр РАН., д.м.н., профессор",
          icon: "lopatin.png",
        },
        {
          time: "10:05-10:25",
          title:
            "DELIVER! Новые возможности в лечении ХСН во всем диапазоне ФВ ЛЖ",
          description: "Терещенко С.Н. Д.м.н., профессор",
          icon: "tereshenko.png",
        },
        {
          time: "10:25-10:45",
          title:
            "«Глоток свежего воздуха» в клинических рекомендациях по терапии ХСН",
          description: "Жиров И.В. Д.м.н., профессор",
          icon: "jirov.png",
        },
        {
          time: "10:45-11:00",
          title:
            "<span style='margin-top: 15px; display: block'>Дискуссия, ответы на вопросы аудитории</span> <br><br> <span style='color: #2186AF'>Панельная дискуссия</span>",
          icon: "talking.png",
          description: "",
        },
        {
          time: "11:00-11:20",
          title:
            "СД2 – краеугольный камень в структуре кардио-метаболических нарушений",
          icon: "mkrtumyan.png",
          description: "Мкртумян А.М. Д.м.н., профессор, заслуженный врач РФ",
        },
        {
          time: "11:20-11:40",
          title:
            "Пациент с ХСН и ХБП: стратегия управления прогнозом в новой реальности",
          description: "Калашников В.Ю. Член-кор РАН, профессор, д.м.н.",
          icon: "kobalava.png",
        },
        {
          time: "11:40-12:00",
          title: "Дискуссия, ответы на вопросы аудитории",
          description: "",
          icon: "talking.png",
        },
        {
          time: "12:00-12:30",
          title:
            "<span style='margin-top: 15px; display: block'>Перерыв</span> <br><br> <span style='color: #2186AF'>Панельная дискуссия «Многоликая» СНсФВ: что мы знаем и не знаем о ней?»</span>",
          description:
            "Лопатин Ю.М. Член-корр РАН., д.м.н., профессор, Агеев Ф.Т. Д.м.н., профессор, Овчинников А.Г. Д.м.н.",
          icon: "coffee.png",
        },
        {
          time: "12:30-12:50",
          title: "Современное представление о СНсФВ",
          icon: "ageev.png",
          description: "Агеев Ф.Т. Д.м.н., профессор",
        },
        {
          time: "12:50-13:10",
          title: "Современные критерии диагностики СНсФВ",
          icon: "ovchinnikov.png",
          description: "Овчинников А.Г. Д.м.н.",
        },
        {
          time: "13:10-13:30",
          title: "Дискуссия, ответы на вопросы аудитории",
          description: "",
          icon: "talking.png",
        },
        {
          time: "13:30-13:50",
          title: "От клинических вопросов к маршрутизации пациентов с ХСН",
          description: "Виллевальде С.В. Д.м.н., профессор",
          icon: "villevalde.png",
        },
        {
          time: "13:50-14:10",
          title: "Дискуссия, ответы на вопросы аудитории",
          icon: "talking.png",
          description: "Все эксперты",
        },
        {
          time: "14:10-14:30",
          title:
            "Закрытие мероприятия <br> Всем сердцем с DELIVER для покорения новых горизонтов терапии ХСН",
          icon: "lopatin.png",
          description: "Лопатин Ю.М. Член-корр РАН, д.м.н., профессор",
        },
      ];
    },

    galaxyProgramm() {
      let html = ``;
      let block = ``;
      for (let item of this.program) {
        block += `
              <div class="hobl__program-item">
                <div class="hobl__program-time">${item.time}</div>
                <div class="d-flex align-start hobl__program-info">
                  <img class="mr-2" src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/forsiga/${item.icon}"  />
                  <div class="hobl__program-info my-auto">
                    <div class="hobl__program-title">
                    ${item.title}
                    </div>
                    <div style="${
                      item.description ? "" : "display: none"
                    }" class="hobl__program-description">
                      ${item.description}
                    </div>
                  </div>
                </div>
              </div>
            </div>`;
      }
      html = `<div class="hobl__program mb-8">${block}</div>`;
      return html;
    },
  },
  methods: {
    ...mapActions([
      "fetchEventsCalendar",
      "fetchTextMaterials",
      "fetchVideoMaterials",
      "fetchPodcasts",
    ]),
    clickMaterials(name) {
      const vm = this;
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "forsiga", {
          forsiga: {
            "material click": {
              [name]: {
                ...this.$root.ymFields,
              },
            },
          },
        });
      }
    },
    findWord(w, d, n, s, rp) {
      let otp_wjs_dt = new Date().getTime();
      w[n] = w[n] || [];
      rp = {};
      w[n].push(function () {
        otp_render_widget(
          d.getElementById("otp_wgt_xcxkw37edfwka"),
          "onlinetestpad.com",
          "xcxkw37edfwka",
          rp
        );
      });
      s = d.createElement("script");
      s.type = "text/javascript";
      s.src = "//onlinetestpad.com/js/widget.js?" + otp_wjs_dt;
      s.async = true;
      d.getElementsByTagName("head")[0].appendChild(s);
    },
    digitalQuiz() {
      let s = document.createElement("script");
      s.type = "text/javascript";
      s.src = "//embed.typeform.com/next/embed.js";
      s.async = true;
      document.getElementsByTagName("head")[0].appendChild(s);
    },
    feedback() {
      let s = document.createElement("script");
      s.type = "text/javascript";
      s.src = "//yastatic.net/s3/frontend/forms/_/embed.js";
      s.async = true;
      document.getElementsByTagName("head")[0].appendChild(s);
    },
    async toRegister(reg_button) {
      if (reg_button) {
        if (typeof ym !== "undefined") {
          ym(91468266, "reachGoal", "forsiga", {
            forsiga: {
              "reg click": {
                ...this.$root.ymFields,
              },
            },
          });
        }
      } else {
        if (typeof ym !== "undefined") {
          ym(91468266, "reachGoal", "forsiga", {
            forsiga: {
              "join click": {
                ...this.$root.ymFields,
              },
            },
          });
        }
      }
      localStorage.setItem("source", `forsiga0209`);
      localStorage.setItem("backUrl", JSON.stringify({ name: "Forsiga" }));
      // const route = this.$router.resolve({
      //   name: "Register",
      //   query: { email: this.$route.query.email || "" },
      // });
      // window.open(route.href, "_blank");
      window.open(this.$root.ssoLinks.registration, "_self");
    },
    openInner(programm) {
      if (programm) {
        if (typeof ym !== "undefined") {
          ym(91468266, "reachGoal", "forsiga", {
            forsiga: {
              "program drill down": {
                ...this.$root.ymFields,
              },
            },
          });
        }
      } else {
        if (typeof ym !== "undefined") {
          ym(91468266, "reachGoal", "forsiga", {
            forsiga: {
              "abbreviation click": {
                ...this.$root.ymFields,
              },
            },
          });
        }
      }
    },
    toWidget(type, name) {
      const vm = this;
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "forsiga", {
          forsiga: {
            "widget click": {
              [name]: {
                ...this.$root.ymFields,
              },
            },
          },
        });
      }
      this.popupActivity = true;
      this.popupType = type;
      if (type === "find_word") {
        this.findWord(window, window.document, "otp_widget_callbacks");
      }
      if (type === "digital_quiz") {
        this.digitalQuiz();
      }
      if (type === "feedback") {
        this.feedback();
      }
    },
    timer() {
      let date = new Date();
      const dateEnd = this.$m
        .utc(this.EventDetail.date)
        .utcOffset(+3)
        .subtract(10, "minutes");
      const today = this.$m.utc(date).utcOffset(+3);
      const diff = today.diff(dateEnd, "seconds");
      this.$set(this, "timerResult", {});
      if (diff > 0) return;
      let months = Math.abs(diff) / 2592000;
      let fullMonths = Math.floor(months);
      let days = (months - Math.floor(months)) * 30;
      let fullDays = Math.floor(days);
      let hours = (days - Math.floor(days)) * 24;
      let fullHours = Math.floor(hours);
      let minutes = (hours - Math.floor(hours)) * 60;
      let fullMinutes = Math.floor(minutes);
      let seconds = (minutes - Math.floor(minutes)) * 60;
      let fullSeconds = Math.round(seconds);
      this.$set(this, "timerResult", {});
      if (fullMonths) {
        this.$set(this.timerResult, "months", fullMonths);
      }
      if (fullDays) {
        this.$set(this.timerResult, "days", fullDays);
      }
      if (fullHours) {
        this.$set(this.timerResult, "hours", fullHours);
      }
      if (fullMinutes) {
        this.$set(this.timerResult, "minutes", fullMinutes);
      }
      if (fullSeconds) {
        this.$set(this.timerResult, "seconds", fullSeconds);
      }
    },
    async getCalendar(id) {
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "forsiga", {
          forsiga: {
            "add to calendar": {
              ...this.$root.ymFields,
            },
          },
        });
      }
      const url = await this.fetchEventsCalendar(id);
      let a = document.createElement("a");
      a.style.display = "none";
      document.body.appendChild(a);
      a.href = url;
      a.download = "event.ics";
      a.click();
      setTimeout(async () => {
        window.URL.revokeObjectURL(url);
      }, 1000);
      a.remove();
    },
    
    closePopup() {
      this.popup = false;
    },
    openIframe() {
      if (
        !localStorage.getItem("token") &&
        !!!Object.keys(this.user).length
      ) {
        if(!!!this.$route.query.access) {
           this.popup = true;
        } else {
          // this.openFrame = true;
          this.popup = true;
        }
        // this.openFrame = true;
      } else {
        this.openFrame = true;
      }
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "forsiga", {
          forsiga: {
            "watch broadcast": {
              ...this.$root.ymFields,
            },
          },
        });
      }
    },
    cyclicVideo(duration) {
      const vm = this;
      this.timer = setTimeout(() => {
        if (typeof ym !== "undefined") {
          ym(91468266, "reachGoal", "video 30 sec", {
            "video 30 sec": {
              "video name": vm.EventDetail.name,
              "video duration": duration,
              ...this.$root.ymFields,
            },
          });
        }
        vm.cyclicVideo();
      }, 30000);
    },
  },
  created() {
    this.timer();
    this.interval = setInterval(this.timer, 1000);
  },
  async mounted() {
    const vm = this;

    await this.fetchTextMaterials({
      disease: ["hbp", "hsn", "diabetes"],
    });
    await this.fetchVideoMaterials({
      disease: ["hbp", "hsn", "diabetes"],
    });
    await this.fetchPodcasts({
      disease: ["hbp", "hsn", "diabetes"],
    });
    window.addEventListener("message", this.webinarEnd, false);
    let video = document.querySelector(".event-detail__timer video");
    if (video) {
      video.addEventListener("play", function () {
        if (this.currentTime === 0) {
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "video start", {
              "video start": {
                "video name": vm.EventDetail.name,
                "video duration": Math.round(this.duration),
                ...vm.$root.ymFields,
              },
            });
          }
        } else {
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "video resume", {
              "video resume": {
                "video name": vm.EventDetail.name,
                "video duration": Math.round(this.duration),
                ...vm.$root.ymFields,
              },
            });
          }
        }
        vm.cyclicVideo(Math.round(this.duration));
      });
      video.addEventListener("pause", function () {
        if (this.currentTime !== this.duration) {
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "video pause", {
              "video pause": {
                "video name": vm.EventDetail.name,
                "video duration": Math.round(this.duration),
                ...vm.$root.ymFields,
              },
            });
          }
        }
        clearTimeout(vm.timer);
        vm.timer = null;
      });
      video.addEventListener("ended", function () {
        if (typeof ym !== "undefined") {
          ym(91468266, "reachGoal", "video end", {
            "video end": {
              "video name": vm.EventDetail.name,
              "video duration": Math.round(this.duration),
              ...vm.$root.ymFields,
            },
          });
        }
      });
      video.addEventListener("timeupdate", function () {
        let percent = Math.ceil((this.currentTime / this.duration) * 100);
        if (this.percent !== percent && percent !== 0 && percent % 5 === 0) {
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "video percentage watched", {
              "video percentage watched": {
                "video percentage watched": percent,
                ...vm.$root.ymFields,
              },
            });
          }
          this.percent = percent;
        }
      });
    }
  },
  beforeDestroy() {
    // document.querySelector("#app").style.backgroundImage = "";
    clearInterval(this.interval);
    window.removeEventListener("message", this.webinarEnd, false);
  },
  watch: {
    "$route.params.id": {
      handler: async function () {
        // if (this.$route.params.id && !this.$route.query.access) {
        //   await this.fetchEventDetail({id: this.$route.params.id});
        // }
      },
      deep: true,
      immediate: true,
    },
    async timerResult() {
      if (!Object.keys(this.timerResult).length) {
        clearInterval(this.interval);
      }
    },
    async EventDetail() {
      if (this.EventDetail.external) {
        window.open(this.EventDetail.external_link, "_self");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.popup__text {
  font-family: "Roboto Slab", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 32px;
  text-align: center;
  color: #656969;
}
.timer {
  &__value {
    margin-right: 16px;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 42px;
    line-height: 48px;

    @media screen and (max-width: 767px) {
      margin-right: 0;
      font-size: 32px;
      line-height: 38px;
    }
  }

  &__text {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;

    @media screen and (max-width: 767px) {
      font-size: 16px;
      line-height: 22px;
    }
  }
}
.event-detail {
  padding-top: 64px;
  @media screen and (max-width: 1220px) {
    padding-top: 40px;
  }

  &__tip {
    margin-top: 32px;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #b2b4b4;
  }

  &__description-block {
    margin-bottom: 32px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 48px;
    background-color: #f8f8f8;

    & img {
      height: 220px;
      @media screen and (max-width: 1220px) {
        width: 100%;
        height: auto;
      }

      @media screen and (max-width: 767px) {
        margin: 0 auto;
      }
    }

    @media screen and (max-width: 1220px) {
      display: block;
      padding: 24px;
    }

    @media screen and (max-width: 767px) {
      display: block;
      padding: 16px;
    }
  }

  video {
    width: 100%;
    height: auto;
  }

  &__banner {
    width: 100%;
  }

  &__timer {
    margin-bottom: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 24px 37px;
    border-radius: 16px;
    background: #2186af;
    // background-image: url('https://storage.yandexcloud.net/'+$VUE_APP_BACKET_NAME+'/media/content/public/assets/img/galaxy/timer.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    color: #fff;
    position: relative;

    // &::before,
    // &::after {
    //   width: 100%;
    //   height: 22px;
    //   position: absolute;
    //   left: 0;
    //   background-repeat: no-repeat;
    //   background-size: 100%;
    //   background-color: #f3fdff;
    //   display: block;
    //   content: "";
    // }

    // &::before {
    //   top: 0;
    //   background-image: url('https://storage.yandexcloud.net/'+$VUE_APP_BACKET_NAME+'/media/content/public/assets/img/galaxy/timer_t.png');
    //   background-position: bottom left;
    // }

    //  &::after {
    //   bottom: 0;
    //   background-image: url('https://storage.yandexcloud.net/'+$VUE_APP_BACKET_NAME+'/media/content/public/assets/img/galaxy/timer_b.png');
    //   background-position: top left;
    // }

    @media screen and (max-width: 1220px) {
      flex-direction: column;
      // align-items: flex-start;
    }

    @media screen and (max-width: 767px) {
      padding: 16px;
    }

    &-title {
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 23px;
      line-height: 29px;
      margin-right: auto;

      @media screen and (max-width: 1220px) {
        margin-right: 0;
        margin-bottom: 32px;
      }

      @media screen and (max-width: 767px) {
        font-size: 21px;
        line-height: 26px;
      }
    }

    &-item {
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0 40px;
      &:last-child {
        margin-right: 0;
        &::after {
          display: none;
        }
      }

      &::after {
        display: block;
        content: "";
        width: 1px;
        height: 50%;
        background-color: #fff;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
      }

      @media screen and (max-width: 1220px) {
        padding: 0 15px;
      }

      @media screen and (max-width: 767px) {
        flex-direction: column;
        padding: 0 15px;
      }
    }

    &-row {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      @media screen and (max-width: 1220px) {
        // width: 100%;
      }
    }

    &-date {
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 42px;
      line-height: 48px;
      color: #ffffff;

      @media screen and (max-width: 767px) {
        font-size: 26px;
      }
    }
  }

  &__iframe {
    position: relative;
    width: 100%;
    display: none;

    & iframe {
      width: 100%;
      height: 800px;

      @media screen and (max-width: 1220px) {
        width: 100%;
        height: 100%;
      }
    }

    @media screen and (max-width: 1220px) {
      display: none;
    }
  }

  &__iframe_opened {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999999;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    padding: 64px;

    & iframe {
      height: 100%;
    }

    @media screen and (max-width: 1220px) {
      padding: 0;
    }
  }

  &__close-btn {
    cursor: pointer;
    position: absolute;
    top: 24px;
    left: 24px;
    z-index: 2;

    @media screen and (max-width: 1220px) {
      top: 0;
      right: 50%;
      transform: translateX(50%);
    }
  }

  &__title {
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 42px;
    line-height: 48px;
    color: #1f1f1f;

    @media screen and (max-width: 767px) {
      font-size: 24px;
      line-height: 32px;
    }
  }

  &__translation {
    max-width: 280px;
    // width: 189px;

    @media screen and (max-width: 1220px) {
      width: auto;
    }

    @media screen and (max-width: 767px) {
      width: 100%;
      max-width: none;
    }
  }

  &__date-info {
    border-left: 4px solid #0194ac;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 24px;
    margin-top: 64px;
    margin-bottom: 40px;
    background-color: #f8f8f8;

    @media screen and (max-width: 1220px) {
      flex-direction: column;
      margin-top: 40px;
    }

    @media screen and (max-width: 767px) {
      margin-top: 32px;
    }
  }

  &__about-title {
    margin-bottom: 24px;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 23px;
    line-height: 29px;
    color: #3c4242;
  }

  &__about-description {
    margin-bottom: 32px;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #656969;
  }

  &__date-text {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    @media screen and (max-width: 1220px) {
      flex-direction: column;
    }
  }

  &__date-item {
    margin-right: 32px;

    @media screen and (max-width: 1220px) {
      margin-right: 0;
      margin-bottom: 16px;
    }
  }

  &__date-item-title {
    margin-bottom: 4px;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #b2b4b4;
  }

  &__date-item-value {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #3c4242;
  }

  &__add-calendar {
    width: 280px;
    margin-left: auto;
    @media screen and (max-width: 1220px) {
      width: 100%;
    }
  }
}
</style>

<style lang="scss">
.hobl {
  &__program {
    &-item {
      margin-bottom: 48px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      // background: rgba(0, 0, 0, 0.8);
      // padding: 24px;

      &:last-child {
        margin-bottom: 0;
      }

      @media screen and (max-width: 767px) {
        flex-direction: column;
      }
    }

    &-time {
      width: fit-content;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #2186af;
      padding: 4px 8px;
      border-radius: 99px;
      // background-color: #634075;
      background-color: #f8f8f8;
      margin-right: auto;

      @media screen and (max-width: 767px) {
        margin-bottom: 16px;
      }
    }

    &-info {
      width: 75%;

      & > img {
        width: 50px;
        height: 50px;
        margin-right: 15px;
      }

      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }

    &-title {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
      // color: #ffffff;
      color: #3c4242;
    }

    &-description {
      margin-top: 8px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      // color: #b2b4b4;
      color: #656969;
    }
  }

  &-activities {
    &__title {
      margin-bottom: 24px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 23px;
      line-height: 29px;
      color: #1f1f1f;
    }

    &__description {
      margin-bottom: 24px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #3c4242;
    }

    &__list {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      column-gap: 32px;
      row-gap: 32px;

      @media screen and (max-width: 1219px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media screen and (max-width: 767px) {
        grid-template-columns: repeat(1, 1fr);
      }
    }

    &__item {
      padding: 40px 22px;
      background: #f8f8f8;
      border-radius: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  }

  &-activity {
    &__icon {
      height: 117px;
      margin-bottom: 32px;

      & img {
        height: 100%;
      }
    }

    &__button {
      width: 100%;
      border: 1px solid #2186af;
      color: #2186af;
      background-color: transparent;

      &:hover {
        border-color: #2eb5eb;
        color: #2eb5eb;
      }
    }
  }
}
.event-detail {
  &__warning {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #656969;
    & svg {
      flex-shrink: 0;
    }

    & a {
      text-decoration: underline;
    }
  }
  i {
    font-style: italic !important;
  }

  b,
  strong {
    font-weight: 500 !important;
  }

  ul {
    list-style: disc;
    padding-left: 18px;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #3c4242;
  }

  ol {
    list-style: decimal;
    padding-left: 18px;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #3c4242;
  }

  li {
    margin-bottom: 8px;

    & > ul {
      margin-top: 8px;

      & li {
        color: #656969;
        list-style-type: none;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.first-banner {
  border-radius: 16px;
  overflow: hidden;
  background-color: #e1f6f9;
  height: 419px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  @media screen and (max-width: 1220px) {
    flex-direction: column;
    align-items: stretch;
    height: auto;
  }

  @media screen and (max-width: 767px) {
    border-radius: 0;
  }

  &__title {
    color: #1f1f1f;
    font-family: "Roboto Slab", sans-serif;
    font-size: 42px;
    font-style: normal;
    font-weight: 400;
    line-height: 48px;
    margin-bottom: 24px;

    @media screen and (max-width: 767px) {
      font-size: 32px;
      line-height: 38px;
    }
  }

  &__button {
    width: 200px;

    @media screen and (max-width: 767px) {
      width: 100%;
    }
  }

  &__text {
    padding: 0 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media screen and (max-width: 1220px) {
      padding: 40px;
    }

    @media screen and (max-width: 767px) {
      padding: 24px 16px;
    }
  }

  & picture {
    width: auto;
    height: 100%;

    @media screen and (max-width: 1220px) {
      width: 100%;
      height: auto;
    }
  }

  &__image {
    width: auto;
    height: 100%;

    @media screen and (max-width: 1220px) {
      width: 100%;
      height: auto;
      margin-top: -60px;
    }

    @media screen and (max-width: 767px) {
      margin-top: 0;
    }
  }
}

.bottom-banner {
  height: 340px;
  border-radius: 16px;
  padding: 40px 54px;
  position: relative;
  overflow: hidden;
  margin-top: 64px;

  @media screen and (max-width: 1220px) {
    padding: 40px 32px;
    height: auto;
  }

  @media screen and (max-width: 767px) {
    height: 550px;
    padding: 32px;
  }

  &__logo {
    margin-bottom: 32px;

    @media screen and (max-width: 767px) {
      width: 137px;
      margin-bottom: 24px;
    }

    & svg {
      max-width: 100%;
    }
  }

  &__text {
    position: relative;
    max-width: 430px;
  }

  &__description {
    color: #3c4242;

    font-family: "Roboto", sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;

    @media screen and (max-width: 767px) {
      font-size: 16px;
      line-height: 24px;
    }
  }

  &__button {
    width: 208px;
    margin-top: 24px;
  }

  &__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.slide-lector {
  padding: 24px;
  border-radius: 16px;
  height: 100%;
  background-color: #e1f6f9;

  &__image-container {
    width: 120px;
    height: 120px;
    margin-bottom: 16px;
    border-radius: 50%;
    overflow: hidden;
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }

  &__tag {
    margin-bottom: 16px;
    border-radius: 8px;
    padding: 4px 8px;
    background-color: #2186af;
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    color: #fff;
    width: fit-content;
  }

  &__name {
    margin-bottom: 8px;
    color: #3c4242;
    font-family: "Roboto Slab", sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }

  &__description {
    color: #b2b4b4;
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
  }
}

.default-slider {
  padding: 24px 0;
}
</style>

<style lang="scss">
.find_word {
  margin: 0 auto;

  width: 900px;
  height: 675px;
  @media screen and (max-width: 1220px) {
    width: 100%;
    height: 675px;
  }

  @media screen and (max-width: 767px) {
    width: 100%;
    height: 825px;
  }
}

.digital_quiz {
  margin: 0 auto;

  width: 1000px;
  height: 600px;
  @media screen and (max-width: 1220px) {
    width: 100%;
    height: 550px;
  }

  @media screen and (max-width: 767px) {
    width: 100%;
    height: 500px;
  }
}

.true_false {
  margin: 0 auto;

  width: 1000px;
  height: 600px;
  @media screen and (max-width: 1220px) {
    width: 100%;
    height: 550px;
  }

  @media screen and (max-width: 767px) {
    width: 100%;
    height: 500px;
  }
}

.forsiga + .modal-popup .modal-popup__content {
  max-width: fit-content;
}

.true_false iframe {
  margin: 0 auto;
  width: 100%;
  height: 100%;

  @media screen and (max-width: 1220px) {
    width: 100%;
    // height: 500px;
  }

  @media screen and (max-width: 767px) {
    width: 100%;
    // height: 300px;
  }
}

.feedback iframe {
  margin: 0 auto;
  width: 100%;
  height: 100%;

  @media screen and (max-width: 1220px) {
    width: 100%;
    // height: 500px;
  }

  @media screen and (max-width: 767px) {
    width: 100%;
    // height: 300px;
  }
}

.feedback {
  margin: 0 auto;

  width: 1000px;
  height: 600px;
  overflow-y: auto;
  @media screen and (max-width: 1220px) {
    width: 100%;
    height: 550px;
  }

  @media screen and (max-width: 767px) {
    width: 100%;
    height: 500px;
  }
}

.short-list {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #656969;
}
</style>
